import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { StorageService } from "../services/storage.service";
import { navigateHome } from "../utils/home-route.util";
import { AccessDeniedQueryParam, AccessDeniedReason } from "src/app/features/access-denied/access-denied.constants";

/**
 * `reason=sso` is only meaningful for a user `fallbackRouteGuard` has already
 * confirmed has no session — it says "this login has no matching RC account".
 * A signed-in user hand-navigating to this exact URL (bookmark, back button,
 * shared link) is not that user, so re-check here rather than trusting the
 * query param: otherwise anyone with real access could land on a page telling
 * them their account is invalid, with a button that offers to end their
 * active myzPAX session.
 */
export const accessDeniedGuard: CanActivateFn = (route) => {
  const storageService = inject(StorageService);
  const router = inject(Router);

  if (route.queryParamMap.get(AccessDeniedQueryParam.reason) !== AccessDeniedReason.Sso) {
    return true;
  }

  if (storageService.hasActiveSession()) {
    navigateHome(router, true);
    return false;
  }

  return true;
};
